import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';

import { APP_STORE } from '@core/stores/app.store';
import { Notification } from '@notifications/models/notification';
import { NotificationStatus } from '@notifications/models/notification-status';
import { NotificationsService } from '@notifications/services/notifications.service';
import { NOTIFICATIONS_STORE } from '@notifications/stores/notifications.store';

@Component({
  selector: 'app-notifications-bell',
  templateUrl: './notifications-bell.component.html',
  styleUrls: ['./notifications-bell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatBadge, MatButton, MatIcon, MatProgressBar]
})
export class NotificationsBellComponent {
  readonly #appStore = inject(APP_STORE);
  readonly #notificationsService = inject(NotificationsService);
  readonly #notificationsStore = inject(NOTIFICATIONS_STORE);

  readonly notifications = computed((): Notification[] => {
    const entities = this.#notificationsStore.entities();
    const selectedClientId = this.#appStore.selectedClientId();
    const selectedProjectId = this.#appStore.selectedProjectId();

    return entities.filter(
      n => n.clientId === selectedClientId && n.projectId === selectedProjectId
    );
  });
  readonly anyNotificationInProgress = computed(() =>
    this.notifications().some(n => n.status === NotificationStatus.InProgress)
  );

  constructor() {
    this.#notificationsService.initialize();
  }

  toggleNotificationsSidenav(): void {
    this.#notificationsStore.toggleNotificationsSidenav();
  }
}
